import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Exception } from '@cargos/sprintpay-models';
import { Observable, finalize, from, map, of, switchMap, take } from 'rxjs';
import { LogoFacilityComponent } from 'src/app/shared/components';
import { DynamicDialogService } from 'src/app/shared/components/dynamic-dialog/services/dynamic-dialog.service';
import { MatStrokedButtonBorderDirective } from 'src/app/shared/directives/mat-stroked-button-border.directive';
import { SubscriptionAWBService, SummaryService } from 'src/app/shared/services';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { AwbSubscriptionService } from '../services/awb-subscription.service';
@Component({
    selector: 'app-cancel-autopay',
    standalone: true,
    imports: [
        MatIconModule,
        MatButtonModule,
        LogoFacilityComponent,
        MatDialogModule,
        MatStrokedButtonBorderDirective,
        MatProgressSpinnerModule,
    ],
    templateUrl: './auto-pay-cancel.component.html',
    styleUrl: './auto-pay-cancel.component.scss',
})
export class AutopayCancelComponent implements OnInit {
    public awb: string;
    public loading = false;

    constructor(
        private subscriptionAWBService: SubscriptionAWBService,
        private dynamicDialogService: DynamicDialogService,
        private summaryService: SummaryService,
        private awbSubscriptionService: AwbSubscriptionService
    ) {}

    ngOnInit(): void {
        this.awb = this.summaryService.getMAWB() || '';
    }

    cancel(): void {
        this.cancelModal()
            .pipe(
                take(1),
                switchMap((result) => {
                    Swal.close();
                    if (result.value) {
                        this.loading = true;
                        return this.subscriptionAWBService.cancelAutoPay(this.awb).pipe(map(() => true));
                    }
                    return of(false);
                }),
                finalize(() => (this.loading = false))
            )
            .subscribe({
                next: (isCancel) => {
                    this.dynamicDialogService.closeDialog();
                    if (isCancel) {
                        this.dynamicDialogService.closeDialog();
                        this.awbSubscriptionService.showTooltip(
                            `Success! autopay has been canceled for MAWB ${this.awb} Note: you will still receive an email notification when your shipment is ready.`
                        );
                    }
                },
                error: (error: Exception) => {
                    Swal.fire({
                        title: error.title,
                        text: error.description,
                        icon: error.type,
                    });
                },
            });
    }

    cancelModal(): Observable<SweetAlertResult> {
        return from(
            Swal.fire({
                title: 'Are you sure?',
                icon: 'error',
                html: `This <strong>MAWB number has already been opted in for autoPay.</strong> You may cancel this autoPay, initiate a new search.`,
                allowOutsideClick: false,
                showCancelButton: true,
                cancelButtonText: 'NEW SEARCH',
                showCloseButton: false,
                showConfirmButton: true,
                confirmButtonText: 'CONTINUE',
                reverseButtons: true,
                customClass: {
                    cancelButton:
                        'mdc-button mat-mdc-button-base h-auto mdc-button--outlined mat-mdc-outlined-button mat-primary appMatStrokedButtonBorder',
                    confirmButton:
                        'mdc-button mat-mdc-button-base my-4 mdc-button--unelevated mat-mdc-unelevated-button mat-primary',
                },
            })
        );
    }
}
